import { LangPlugin } from '@/__shared/lang/lib_lang'
import Vue from 'vue'

Vue.use(LangPlugin, { defaultNamespaceScope: 'site' })
